// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box } from '../../../lib/base';
import { AppBarDownMD } from './AppBarDownMD';
import { AppBarUpMD } from './AppBarUpMD';

export function AppBar() {
  return (
    <Box sx={{ bgcolor: 'primary.main' }} id="app-bar-root">
      <Box sx={{ display: { xs: 'none', md: 'initial' } }}>
        <AppBarUpMD />
      </Box>
      <Box sx={{ display: { xs: 'initial', md: 'none' } }}>
        <AppBarDownMD />
      </Box>
    </Box>
  );
}
